<template>
  <transition name="slide-up" appear>
    <div class="modal-horario" v-if="isVisible" v-touch:swipe.down="fecharModal">
      <div v-touch:swipe.down="fecharModal" class="modal-content-horario">
        <div class="drag-area" v-touch:swipe.down="fecharModal">
          <div class="drag-indicator"></div>
        </div>
        <div class="modal-header-horario">
          <div class="header-content-horario">
            <h1>Horário de funcionamento</h1>
          </div>
          <!-- <div class="container-icon" @click="fecharModal" style="cursor:pointer">
            <img src="../../assets/img/svg/Close.svg">
          </div> -->
        </div>
        <div class="modal-body-horario">
          <div class="item-modal-left">
            <div class="item-day">
              <label class="item-day-topic">Segunda-feira</label>
              <label class="item-day-topic">Terça-feira</label>
              <label class="item-day-topic">Quarta-feira</label>
              <label class="item-day-topic">Quinta-feira</label>
              <label class="item-day-topic">Sexta-feira</label>
              <label class="item-day-topic">Sábado</label>
              <label class="item-day-topic">Domingo</label>
              <label class="item-day-topic">Feriados</label>
            </div>
          </div>
          <div class="item-modal-right">
            <div class="item-horarios">
              <label class="item-horarios-topic">
                {{segundaPeriodo1}}
                <span v-if="segundaPeriodo1 !== 'Aberto 24 horas' && segundaPeriodo1 !== 'Não informado'"> | {{ segundaPeriodo2 }}</span>
              </label>
              <label class="item-horarios-topic">
                {{tercaPeriodo1}}
                <span v-if="tercaPeriodo1 !== 'Aberto 24 horas' && tercaPeriodo1 !== 'Não informado'"> | {{ tercaPeriodo2 }}</span>
              </label>
              <label class="item-horarios-topic">
                {{quartaPeriodo1}}
                <span v-if="quartaPeriodo1 !== 'Aberto 24 horas' && quartaPeriodo1 !== 'Não informado'"> | {{ quartaPeriodo2 }}</span>
              </label>
              <label class="item-horarios-topic">
                {{quintaPeriodo1}}
                <span v-if="quintaPeriodo1 !== 'Aberto 24 horas' && quintaPeriodo1 !== 'Não informado'"> | {{ quintaPeriodo2 }}</span>
              </label>
              <label class="item-horarios-topic">
                {{sextaPeriodo1}}
                <span v-if="sextaPeriodo1 !== 'Aberto 24 horas' && sextaPeriodo1 !== 'Não informado'"> | {{ sextaPeriodo2 }}</span>
              </label>
              <label class="item-horarios-topic">
                {{sabadoPeriodo1}}
                <span v-if=" sabadoPeriodo1 !== 'Aberto 24 horas' && sabadoPeriodo1 !== 'Não informado'"> | {{ sabadoPeriodo2 }}</span>
              </label>
              <label class="item-horarios-topic">
                {{domingoPeriodo1}}
                <span v-if=" domingoPeriodo1 !== 'Aberto 24 horas' && domingoPeriodo1 !== 'Não informado'" > | {{ domingoPeriodo2 }}</span>
              </label>
              <label class="item-horarios-topic">
                {{feriadoPeriodo1}}
                <span v-if="feriadoPeriodo1 !== 'Aberto 24 horas' && feriadoPeriodo1 !== 'Não informado'"> | {{ feriadoPeriodo2 }}</span>
              </label>
            </div>
          </div>
        </div>
        <div class="modal-footer-horario">
        </div>
      </div>
    </div>
  </transition>
</template>

<script scoped>
import account from "../../services/account";

export default {
  props: {
    moveMaisIdParceiroSelecionado: undefined,
  },
  data() {
    return {
      isVisible: true,
      segundaPeriodo1: undefined,
      segundaPeriodo2: undefined,
      tercaPeriodo1: undefined,
      tercaPeriodo2: undefined,
      quartaPeriodo1: undefined,
      quartaPeriodo2: undefined,
      quintaPeriodo1: undefined,
      quintaPeriodo2: undefined,
      sextaPeriodo1: undefined,
      sextaPeriodo2: undefined,
      sabadoPeriodo1: undefined,
      sabadoPeriodo2: undefined,
      domingoPeriodo1: undefined,
      domingoPeriodo2: undefined,
      feriadoPeriodo1: undefined,
      feriadoPeriodo2: undefined,
    };
  },

  mounted() {
    this.getHorariosParceiros(this.moveMaisIdParceiroSelecionado);
  },

  methods: {
    getHorariosParceiros(moveMaisId) {
      account.getHorariosParceiros(moveMaisId)
        .then(res => {
          if (res.status.code === 0) {
            this.segundaPeriodo1 = res.listaHorarios.segundaPeriodo1;
            this.segundaPeriodo2 = res.listaHorarios.segundaPeriodo2;
            this.tercaPeriodo1 = res.listaHorarios.tercaPeriodo1;
            this.tercaPeriodo2 = res.listaHorarios.tercaPeriodo2;
            this.quartaPeriodo1 = res.listaHorarios.quartaPeriodo1;
            this.quartaPeriodo2 = res.listaHorarios.quartaPeriodo2;
            this.quintaPeriodo1 = res.listaHorarios.quintaPeriodo1;
            this.quintaPeriodo2 = res.listaHorarios.quintaPeriodo2;
            this.sextaPeriodo1 = res.listaHorarios.sextaPeriodo1;
            this.sextaPeriodo2 = res.listaHorarios.sextaPeriodo2;
            this.sabadoPeriodo1 = res.listaHorarios.sabadoPeriodo1;
            this.sabadoPeriodo2 = res.listaHorarios.sabadoPeriodo2;
            this.domingoPeriodo1 = res.listaHorarios.domingoPeriodo1;
            this.domingoPeriodo2 = res.listaHorarios.domingoPeriodo2;
            this.feriadoPeriodo1 = res.listaHorarios.feriadoPeriodo1;
            this.feriadoPeriodo2 = res.listaHorarios.feriadoPeriodo2;
          }
        })
        .catch(error => {
          console.log(error, "erro do catch");
        });
    },

    fecharModal() {
      this.$emit("fecharModal", 1);
    },
  },
};
</script>

<style scoped>
.modal-horario {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 99999;
}

.modal-content-horario {
  background: white;
  padding: 20px;
  border-radius: 10px 10px 0 0;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  position: relative;
  height: 65%; /* ocupa metade da tela */
}

.drag-area {
  height: 30px; /* Aumenta a altura da área de arrasto */
  cursor: pointer;
}

.drag-indicator {
  width: 50px;
  height: 5px;
  background: #ccc;
  border-radius: 2.5px;
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
}

.modal-header-horario {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-content-horario {
  flex-grow: 0;
}

.container-icon {
  display: flex;
  align-items: center;
}

.modal-body-horario {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.item-modal-left,
.item-modal-right {
  display: flex;
  flex-direction: column;
}

.item-day {
  display: flex;
  flex-direction: column;
  margin-top: -18px;
  margin-left: -16px;
}

.item-day-topic {
  margin: 5px 0;
  border: solid 1px #F2EFF5;
  border-top: none;
  border-right: none;
  border-left: none;
  color: var(--Foundation-Shade-shade-300, #656C77);
  padding: 2px;
  width: 150px;
  font-family: "Open Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 171.429% */
  letter-spacing: 0.5px;
}

.item-horarios {
  display: flex;
  flex-direction: column;
  margin-top: -10px;
  gap: 6px;
}

.item-horarios-topic {
  margin: 5px 0;
  border: solid 1px #F2EFF5;
  border-top: none;
  border-right: none;
  border-left: none;
  color: var(--Foundation-Shade-shade-300, #656C77);
  padding: 2px;
  font-family: "Open Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 171.429% */
  letter-spacing: 0.5px;
  margin-top: -1.7px;
  width: 234px;
}

.modal-footer-horario {
  margin-top: 20px;
}

h1 {
  font-size: 20px;
  font-weight: 600;
  font-family: 'Ro';
}

/* Transição para a modal aparecer de baixo para cima */
.slide-up-enter-active, .slide-up-leave-active {
  transition: all 0.5s ease;
}
.slide-up-enter, .slide-up-leave-to /* .slide-up-leave-active no Vue <2.1.8 */ {
  transform: translateY(100%);
}
</style>



// WEBPACK FOOTER //
// partner-information-modal-mobile.vue?1b453c0f